import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { BildVO } from '../auftragdetails.model';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'auftrag-bilder-komponente',
    template: `
    <div class="section">
      <h1 *ngIf="getEinstellung('Titel')">{{ getEinstellung('Titel') }}</h1>

      <div class="fotos-container">
        <div *ngIf="auftragdetails.auftragsbilder.length">
          <ion-list class="no-lines">
            <ion-item *ngFor="let p of auftragdetails.auftragsbilder" class="ion-no-padding" lines="none">
              <div class="bild-wrapper">
                <img class="bild" [src]="domSanitizationService.bypassSecurityTrustUrl(p.src)" appClick (clicked)="onBildClicked(p)" />
                <div class="bild-kommentar" *ngIf="p.bezeichnung">{{ p.bezeichnung }}</div>
              </div>
            </ion-item>
          </ion-list>
        </div>
      </div>

      <ion-button *ngIf="!auftragdetails.istAuftragAbgeschlossen" appClick (clicked)="onFotoAufnehmen()" class="button-md button-border" expand="full" color="light">Foto aufnehmen</ion-button>
      <ion-button *ngIf="!auftragdetails.istAuftragAbgeschlossen" appClick (clicked)="onFotoAuswaehlen()" class="button-md button-border" expand="full" color="light">Foto aus Galerie auswählen</ion-button>
    </div>
    `,
    styles: [`
    .bild-wrapper {
        width: 100%;
        margin-bottom: 5px;
    }
    .bild {
        max-width: 100%;
        max-height: 300px;
    }
    .bild-kommentar {
        font-size: 0.85em;
        color: var(--ion-color-medium, #666);
        white-space: pre-wrap;
        word-break: break-word;
        padding: 2px 0 5px;
    }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragBilderComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private router: Router,
        public domSanitizationService: DomSanitizer,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    async onFotoAufnehmen() {
        await this.auftragdetails.onFotoAufnehmen();
    }

    async onFotoAuswaehlen() {
        await this.auftragdetails.onFotoAuswaehlen();
    }

    onBildClicked(vo: BildVO) {
        this.auftragdetails.onBildClicked(vo);
    }
}
